import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createSelector } from 'reselect';
import { parse, stringify } from 'query-string';
import { CheckboxFilters, ACTIVITY_TYPE, CLIENT_TYPES } from 'constants/filters';

var getStringByData = function getStringByData(data, currentKey) {
  if (data != null && data.length) {
    return data.reduce(function (res, cur, index) {
      return "".concat(res).concat(currentKey, "[]=").concat(cur).concat(index !== data.length - 1 ? '&' : '');
    }, '');
  }

  return '';
}; // After adding keys, check ("actions/products" --> fetchProductsIds) if you need to exclude them from the request parameters


export var routerStateValuesConfig = {
  organizationSlug: {
    name: 'organizationSlug',
    urlPart: function urlPart() {
      return 'path';
    },
    type: 'params',
    getFormattedValue: function getFormattedValue(value) {
      return value || '';
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue, _ref) {
      var organization = _ref.organization;
      return !!organization && "vendor_id=".concat(organization == null ? void 0 : organization.id);
    },
    getQuery: function getQuery(value) {
      return value || '';
    }
  },
  page: {
    name: 'page',
    urlPart: function urlPart() {
      return 'path';
    },
    type: 'path',
    getFormattedValue: function getFormattedValue(value) {
      return value || '';
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue, _ref2) {
      var page = _ref2.page;
      return !!page && "product_client_type[]=".concat(page);
    },
    getQuery: function getQuery(value) {
      return value || '';
    }
  },
  clientType: {
    name: 'clientType',
    urlPart: function urlPart() {
      return 'path';
    },
    type: 'params',
    getFormattedValue: function getFormattedValue(value) {
      return value || '';
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue, _ref3) {
      var clientType = _ref3.clientType;
      return !!clientType && clientType === CLIENT_TYPES.it && "product_client_activity_type[]=j";
    },
    getQuery: function getQuery(value) {
      return value || '';
    }
  },
  monthlyFee: {
    name: 'monthlyFee',
    urlPart: function urlPart() {
      return 'search';
    },
    type: 'search',
    getFormattedValue: function getFormattedValue(value) {
      return value || '';
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue, _ref4) {
      var _ref4$monthlyFee = _ref4.monthlyFee,
          monthlyFee = _ref4$monthlyFee === void 0 ? [] : _ref4$monthlyFee;
      return monthlyFee.includes('free') && "monthly_fee=0";
    },
    getQuery: function getQuery(value) {
      return value || '';
    }
  },
  currency: {
    name: 'currency',
    urlPart: function urlPart() {
      return 'search';
    },
    type: 'select',
    getFormattedValue: function getFormattedValue(value) {
      return value || '';
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue, _ref5) {
      var currency = _ref5.currency;
      return !!currency && "currency=".concat(currency.toUpperCase());
    },
    getQuery: function getQuery(value) {
      return value || '';
    }
  },
  activityType: {
    name: 'activityType',
    urlPart: function urlPart() {
      return 'search';
    },
    type: 'multiSelect',
    getFormattedValue: function getFormattedValue(value) {
      return value || [];
    },
    getQuery: function getQuery(value) {
      return value.filter(function (el) {
        return Object.keys(ACTIVITY_TYPE).includes(el);
      }) || [];
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue, _ref6) {
      var activityType = _ref6.activityType;
      return !!activityType && filterValue !== CLIENT_TYPES.it && activityType.reduce(function (res, type) {
        return "".concat(res ? "".concat(res, "&") : '', "product_client_activity_type[]=".concat(type.toLowerCase()));
      }, '');
    }
  },
  platforms: {
    name: 'platforms',
    urlPart: function urlPart() {
      return 'search';
    },
    type: 'checkbox',
    getFormattedValue: function getFormattedValue(value) {
      return value || [];
    },
    getQuery: function getQuery(value) {
      return (value == null ? void 0 : value.split(',').filter(function (el) {
        return Object.keys(CheckboxFilters.platforms).includes(el);
      })) || [];
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue) {
      return getStringByData(filterValue, 'platforms');
    }
  },
  finance: {
    name: 'finance',
    urlPart: function urlPart() {
      return 'search';
    },
    type: 'checkbox',
    getFormattedValue: function getFormattedValue(value) {
      return value || [];
    },
    getQuery: function getQuery(value) {
      return (value == null ? void 0 : value.split(',').filter(function (el) {
        return Object.keys(CheckboxFilters.finance).includes(el);
      })) || [];
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue) {
      return getStringByData(filterValue, 'finance');
    }
  },
  account: {
    name: 'account',
    urlPart: function urlPart() {
      return 'search';
    },
    type: 'checkbox',
    getFormattedValue: function getFormattedValue(value) {
      return value || [];
    },
    getQuery: function getQuery(value) {
      return (value == null ? void 0 : value.split(',').filter(function (el) {
        return Object.keys(CheckboxFilters.account).includes(el);
      })) || [];
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue) {
      return getStringByData(filterValue, 'account');
    }
  },
  acquiring: {
    name: 'acquiring',
    urlPart: function urlPart() {
      return 'search';
    },
    type: 'checkbox',
    getFormattedValue: function getFormattedValue(value) {
      return value || [];
    },
    getQuery: function getQuery(value) {
      return (value == null ? void 0 : value.split(',').filter(function (el) {
        return Object.keys(CheckboxFilters.acquiring).includes(el);
      })) || [];
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue) {
      return getStringByData(filterValue, 'acquiring');
    }
  },
  additionally: {
    name: 'additionally',
    urlPart: function urlPart() {
      return 'search';
    },
    type: 'checkbox',
    getFormattedValue: function getFormattedValue(value) {
      return value || [];
    },
    getQuery: function getQuery(value) {
      return (value == null ? void 0 : value.split(',').filter(function (el) {
        return Object.keys(CheckboxFilters.additionally).includes(el);
      })) || [];
    },
    getProductsAPIFilters: function getProductsAPIFilters(filterValue) {
      return getStringByData(filterValue, 'additionally');
    }
  }
};
export var getParsedRouterLocationSearch = createSelector(function (state, props) {
  return props.location.search;
}, function (routerLocationSearch) {
  return parse(routerLocationSearch);
});
export var getFormattedRouterLocationSearch = createSelector(getParsedRouterLocationSearch, function (parsedRouterLocationSearch) {
  return Object.keys(routerStateValuesConfig).reduce(function (result, key) {
    var stateKeyConfig = routerStateValuesConfig[key];

    if (stateKeyConfig.type !== 'checkbox') {
      return result;
    }

    if (!stateKeyConfig.getQuery(parsedRouterLocationSearch[key]).length) return result;
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, stateKeyConfig.name, stateKeyConfig.getQuery(parsedRouterLocationSearch[key])));
  }, {});
});

var getFormattedRouterParams = function getFormattedRouterParams(routerMatchParams) {
  return Object.keys(routerStateValuesConfig).reduce(function (result, key) {
    var stateKeyConfig = routerStateValuesConfig[key];

    if (stateKeyConfig.urlPart() !== 'path') {
      return result;
    }

    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, stateKeyConfig.name, stateKeyConfig.getFormattedValue((routerMatchParams == null ? void 0 : routerMatchParams[key]) || '')));
  }, {});
};

export var getFormattedRouterMatchParams = createSelector(function (state, props) {
  return props.params;
}, function (routerMatchParams) {
  return getFormattedRouterParams(routerMatchParams);
});
export var makeGetFormattedRouterUrlState = function makeGetFormattedRouterUrlState() {
  return createSelector(getFormattedRouterLocationSearch, getFormattedRouterMatchParams, function (formattedRouterLocationSearch, formattedRouterMatchParams) {
    return _objectSpread(_objectSpread({}, formattedRouterLocationSearch), formattedRouterMatchParams);
  });
};
export var getFormattedRouterUrlState = makeGetFormattedRouterUrlState();
export var getSearchParams = createSelector(function (state, props) {
  return props.location.search;
}, function (search) {
  return search;
});
export var getParsedSearchParams = createSelector(function (state, props) {
  return props.location.search;
}, function (search) {
  return parse(search, {
    arrayFormat: 'comma'
  });
});
export var getFormattedSearchParams = createSelector(getParsedSearchParams, function (searchParams) {
  return Object.keys(searchParams).reduce(function (res, key) {
    if (Array.isArray(searchParams[key])) {
      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, searchParams[key]));
    }

    return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, [searchParams[key]]));
  }, {});
});
export var getDynamicLocationSearch = function getDynamicLocationSearch(_ref7, value, options) {
  var search = _ref7.search;

  var newLocationSearchObject = _objectSpread(_objectSpread({}, parse(search)), Object.keys(value).reduce(function (result, key) {
    var _routerStateValuesCon = routerStateValuesConfig[key],
        getFormattedValue = _routerStateValuesCon.getFormattedValue,
        name = _routerStateValuesCon.name;
    var formattedValue = getFormattedValue(value[key], options);
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, name, formattedValue));
  }, {}));

  var newLocationSearchValuesString = stringify(Object.keys(newLocationSearchObject).reduce(function (result, key) {
    if (!newLocationSearchObject[key]) {
      return result;
    }

    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, newLocationSearchObject[key]));
  }, {}), {
    arrayFormat: 'comma'
  });
  return newLocationSearchValuesString.length ? "?".concat(newLocationSearchValuesString) : '';
};